const ROBOTIC_DATA_ALLOWED_ROLES = new Set(['operator', 'admin']);

// The subscriber-facing Robotic Data workspace has moved out of this app.
// Keep the implementation in place so it can be restored without deleting
// the legacy components.
export const ROBOTIC_DATA_UI_ENABLED = false;

export function hasRoboticDataAccess(userRole) {
    const normalizedRole = String(userRole || '').trim().toLowerCase();
    return ROBOTIC_DATA_UI_ENABLED && ROBOTIC_DATA_ALLOWED_ROLES.has(normalizedRole);
}

export const ROBOTIC_DATA_ACCESS_ERROR = 'Robotic data access required.';
